import { Avatar, Button, Flex, Table, Text } from "@mantine/core";
import config from "config";
import dayjs from "dayjs";
import { Sports } from "modules/news/types";
import { sportTypeConverter } from "utils/sportTypeConverter";

const elements = [
  { position: 6, symbol: "C", name: "Carbon" },
  { position: 7, symbol: "N", name: "Nitrogen" },
  { position: 39, symbol: "Y", name: "Yttrium" },
  { position: 56, symbol: "Ba", name: "Barium" },
  { position: 58, symbol: "Ce", name: "Cerium" },
];

interface Props {
  sports: Sports[] | undefined;
  handleEdit: (id: number) => void;
  handleDelete: (id: number) => void;
}

const TableContactForm = (props: any) => {
  const { sports, handleEdit, handleDelete } = props;

  const rows = sports?.map((element: any) => (
    <Table.Tr key={element.id}>
      <Table.Td>
        <Text className="truncate w-[120px] overflow-hidden">
          {element.fullName}
        </Text>
      </Table.Td>
      <Table.Td>
        <Text className="truncate w-[120px] overflow-hidden">
          {element.ipAddress}
        </Text>
      </Table.Td>
      <Table.Td>
        <Text className="truncate w-[120px] overflow-hidden">
          {element.email}
        </Text>
      </Table.Td>
      <Table.Td>
        <Text className="truncate w-[120px] overflow-hidden">
          {element.subject}
        </Text>
      </Table.Td>
      <Table.Td>
        <Text className="truncate w-[120px] overflow-hidden">
          {element.status}
        </Text>
      </Table.Td>

      {/* <Table.Td>{dayjs(element.releaseDate).format("DD-MM-YYYY")}</Table.Td> */}
      <Table.Td>
        <Flex justify={"end"}>
          <Button
            mr={10}
            variant="light"
            onClick={() => handleEdit(element.id)}
          >
            Edit
          </Button>
          {/* <Button
            variant="light"
            color="red"
            onClick={() => handleDelete(element.id)}
          >
            O'chirish
          </Button> */}
        </Flex>
      </Table.Td>
    </Table.Tr>
  ));

  return (
    <Table
      withColumnBorders
      horizontalSpacing={"md"}
      striped
      highlightOnHover
      withTableBorder
    >
      <Table.Thead>
        <Table.Tr>
          <Table.Th>Full name</Table.Th>
          <Table.Th>IP address</Table.Th>
          <Table.Th>Email</Table.Th>
          <Table.Th>Subject</Table.Th>
          <Table.Th>Status</Table.Th>

          <Table.Th className="text-center" w={100} />
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>{rows}</Table.Tbody>
    </Table>
  );
};

export default TableContactForm;
